<div class="calendar-errors-toaster" *ngIf="!toasterClosed" [attr.data-test]="'calendar-errors-toaster'">
	<div class="toaster-content">
		<app-icon
			class="warning-icon"
			[color]="'var(--errors-color)'"
			[lineWidth]="'1.5'"
			[size]="'24'"
			[name]="'warning'"
		>
		</app-icon>

		<span class="toaster-message" [attr.data-test]="'calendar-error-toaster-message'">
			Calendar errors detected across {{ itemsToDisplay() }} since
			{{ calendarTimeStamp() | date : "dd/MM/yyyy HH:mm" }}.
			<span
				class="toaster-view-details"
				(click)="viewDetails()"
				[attr.data-test]="'calendar-error-toaster-view-error-list-button'"
				>View details</span
			>
		</span>
	</div>
	<span class="toaster-exit-button" (click)="closeToaster()" [attr.data-test]="'calendar-error-toaster-close-button'">
		<app-icon
			class="warning-icon"
			id="exit-button"
			[lineWidth]="'2'"
			[size]="'15'"
			[name]="'exit-button'"
			[color]="'var(--errors-color)'"
		></app-icon>
	</span>
</div>

<app-calendar-error-side-panel
	*ngIf="openCalendarErrorSidePanel()"
	(closeCalendarErrorSidePanel)="openCalendarErrorSidePanel.set($event)"
	[calendarErrorRecords]="calendarErrorRecords()"
></app-calendar-error-side-panel>
